<template>
  <div id="withdraw_message_new">
    <van-col span="24" class="withdraw_message_bg">
      <!-- 顶部导航栏 -->
      <van-nav-bar :title="$t('title.arrival_notice')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
      <!-- 消息列表 -->
      <van-col span="24">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('other.there_is_no_more')"
            :loading-text="$t('other.Loading')"
            @load="onLoad"
        >
          <van-cell v-for="(t,i) in list" :key="i" >
            <!-- 时间显示 -->
            <van-col span="24" class="withdraw_message_time"> {{ shouldShowTime(t.show_time, i) }}</van-col>
            <van-col span="24" class="withdraw_message_centent">
              <van-col span="4" class="withdraw_message_centent_left">
                <img src="../assets/img/withdraw_message_icon2.png"/>
              </van-col>
              <van-col span="21" class="withdraw_message_centent_right">
                <van-col span="22" offset="1" class="withdraw_message_centent_right_title"> {{ t.title }} </van-col>
                <van-col span="22" offset="1" class="withdraw_message_centent_right_payment">{{ $t('wallet.withdrawal_amount') }} <span>${{ t.withdrawal_amount }}  </span></van-col>
                <van-col span="22" offset="1" class="withdraw_message_centent_right_payment">{{ $t('wallet.service_fee') }} <span>{{ t.service_fee }}</span> </van-col>
                <van-col span="22" offset="1" class="withdraw_message_centent_right_payment" v-if="t.time_taken > 0">{{ $t('wallet.time_taken') }} <span>{{ t.time_taken }}min</span> </van-col>
                <van-col span="24" class="withdraw_message_centent_right_cell"> 
                    <van-cell :title="$t('column.check_details')" is-link @click="viewOrderDetail(t)" />
                </van-col>
              </van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
    </van-col>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import axios from "axios";

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1,
    }
  },
  created() {
    this.get_list()
  },
  methods: {
    shouldShowColor(status){
      switch (status) {
        case 0:
          return '#FFF0FD'
        case 1:
          return '#F1FFF6'
        case 2:
          return '#FFE8E8'
        default:
          return '#e0e0e0'
      }
    },
    shouldShowTime(currentTime, index) {
      // 第一条消息总是显示时间
      if (index === 0) return this.formatTime(currentTime);
      const prevTime = this.list[index - 1].show_time;
      const timeDiff = prevTime - currentTime;
      // 检查是否超过5分钟（300秒）
      if (timeDiff > 300) {
        return this.formatTime(currentTime);
      }
      return '';
    },

    formatTime(timestamp) {
      const date = new Date(timestamp * 1000);
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const period = hours >= 12 ? 'PM' : 'AM';
      const hour12 = hours % 12 || 12;
      const minuteStr = minutes < 10 ? '0' + minutes : minutes;
      // 判断日期
      if (date >= today) {
        // 今天 - 显示时间
        return `${hour12}:${minuteStr} ${period}`;
      } else {
        // 更早日期
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${month}/${day} ${hour12}:${minuteStr} ${period}`;
      }
    },
    onLoad() {
      // 异步更新数据
      if (this.page > 1) {
        this.get_list()
      }
    },
    get_list(){
      this.loading = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_center&act=withdraw_message_list_new",{
        params:{
          uid: uid,
          token: token,
          page: this.page
        }
      }).then(res =>{
        this.loading = false;
        if(res.data.status ===1){
          if (this.page === 1) {
            this.list = []
          }
          for (let j = 0; j < res.data.list.length; j++) {
            this.list.push(res.data.list[j])
          }
          //如果列表数据条数< 10，不再触发滚动加载
          if (res.data.list.length < 10) {
            this.finished = true
          }
          this.page ++
        }else{
          Toast(res.data.error)
        }
      })
    },
    onClickLeft() {
        // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    viewOrderDetail(item) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      const orderId = item.order_id
      
      // 根据receiver_type判断当前用户身份
      // receiver_type: 0=提现申请人（普通用户），1=结算专员
      if(item.receiver_type == 1){
        // 结算专员身份，跳转到审核页面
        this.$router.push({ path: '/approve_order', query: { uid: uid, token: token, order_id: orderId } })
      } else {
        // 提现用户身份，跳转到订单详情页面
        this.$router.push({ path: '/withdraw_payroll_order', query: { uid: uid, token: token, order_id: orderId } })
      }
    },
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/withdraw_message_new.vue